export const styles = {
  container: 'tw-flex tw-items-start tw-gap-2',
  checkbox:
    'tw-mt-1 tw-box-border tw-w-4 tw-h-4 tw-min-w-4 tw-min-h-4 tw-max-w-4 tw-max-h-4 tw-shrink-0 tw-flex-none tw-rounded tw-border tw-border-neutral-300 tw-bg-white tw-cursor-pointer tw-transition-colors checked:tw-bg-primary-600 checked:tw-border-primary-600 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-primary-100 focus:tw-ring-offset-1 disabled:tw-cursor-not-allowed disabled:tw-bg-neutral-100 disabled:tw-border-neutral-200',
  label:
    'tw-text-sm tw-text-neutral-700 tw-cursor-pointer tw-select-none tw-min-w-0 tw-flex-1 tw-break-words tw-break-all',
  labelDisabled: 'tw-text-neutral-400 tw-cursor-not-allowed',
};
